// import React from 'react';
// import { Select as SelectAntd, SelectProps } from 'antd';
import './style.less';
export interface TabOptions {
  values: Array<string>;
  selectedIndex: number;
  onTabPress: (val: number) => void;
}
function Tab({ values, selectedIndex, onTabPress }: TabOptions) {
  return (
    <div className="tab_wrapper" style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
      {values?.map((item, index) => {
        return (
          <div
            key={item}
            style={{
              width: '100%',
              cursor: 'pointer',
              // paddingBottom: '10px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              color: selectedIndex === index ? '#000' : '#6F7072',
              // borderTop: selectedIndex === index ? '4px solid #C21A17' : 'none',
              // borderBottom: selectedIndex === index ? 'none' : '1px solid #B1B2B4',
              backgroundColor: selectedIndex === index ? '#fff' : '#EBEBEB',
              borderRight: index === 0 && selectedIndex == 0 ? '#B1B2B4' : 'none',
              borderLeft: index === 1 && selectedIndex == 1 ? '#B1B2B4' : 'none',
              marginTop: 20,
              height: '61px',
              lineHeight: '61px',
              fontSize: '26px',
              fontFamily: 'Roboto400',
            }}
            className={selectedIndex === index ? 'active_tab' : 'no_active'}
            onClick={() => onTabPress(index)}
          >
            {item}
          </div>
        );
      })}
    </div>
  );
}

export default Tab;
